export class CalendarDots {
  static NORMALDATE = "normalDate";
  static EVENTDATE = "eventDate";
  static RESERVEDDATE = "reservedDate";

  static CalendarDotsList = [
    {
      key: CalendarDots.NORMALDATE,
      value: "Normal Date",
      color: "var(--primary-color)",
    },
    {
      key: CalendarDots.EVENTDATE,
      value: "Event Date",
      color: "orange",
    },
    {
      key: CalendarDots.RESERVEDDATE,
      value: "Reserved Date",
      color: "green",
    },
  ];

  static getColorViaKey = (key) => {
    return (
      CalendarDots.CalendarDotsList.find((item) => item.key === key)?.color ??
      "Calendar dots Not Found"
    );
  };
}
